export default "__VITE_ASSET__CvnMe435__"